import { render, staticRenderFns } from "./OutputTabs.vue?vue&type=template&id=75bef8f1"
import script from "./OutputTabs.vue?vue&type=script&lang=js"
export * from "./OutputTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports